enum CategoryPreference {
  BEACH = 'BEACH',
  MOUNTAIN = 'MOUNTAIN',
   GASTRONOMY = 'GASTRONOMY',
  CULTURE = 'CULTURE',
  UNAVOIDABLE = 'UNAVOIDABLE',
}

export default CategoryPreference;
